module.exports = __webpack_public_path__ + "static/media/proximanova-bold.589dca41.otf";